import { prepareCssAngle, getRectAngleBound } from '../angle-utils.js';
import {
  colorStopToString,
  calculateLinearStop,
  fixTransparentColorStops,
} from '../color-utils.js';

/**
 * Render a linear gradient
 * @param {CanvasRenderingContext2D} context - Canvas context
 * @param {Object} gradientDef - Gradient definition from parser
 * @param {Object} bounds - Bounding box { x, y, w, h }
 * @returns {CanvasGradient} Canvas gradient object
 */
export function renderLinearGradient(context, gradientDef, { x, y, w, h }) {
  const angle = prepareCssAngle(gradientDef.orientation);

  // Calculate boundary points using width and height
  const startBound = getRectAngleBound(w, h, angle.revTheta);
  const endBound = getRectAngleBound(w, h, angle.theta);

  const start = { x: startBound.x, y: startBound.y };
  const end = { x: endBound.x, y: endBound.y };

  const gradient = context.createLinearGradient(x + start.x, y + start.y, x + end.x, y + end.y);

  // Clone colorStops to avoid mutating the original
  const colorStops = gradientDef.colorStops.map((stop) => ({ ...stop }));

  // Fix transparent color stops to match CSS premultiplied alpha behavior
  fixTransparentColorStops(colorStops);

  const distance = Math.hypot(end.x - start.x, end.y - start.y);

  colorStops.forEach((stop, index) => {
    const position = calculateLinearStop(stop, index, colorStops.length, distance);
    const colorValue = colorStopToString(stop);

    if (colorValue) {
      gradient.addColorStop(Math.max(0, Math.min(1, position)), colorValue);
    }
  });

  return gradient;
}
